export default __webpack_public_path__ + "static/media/JOE.eade8ad9.png";